import React from 'react';
import { Banner, SectionHeader } from '@trevor/ui-components';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getDashboardState } from '@/features/dashboardShare/store-selectors';
import { ConfigureEmbedDashboardButton } from '@/features/dashboard/components/SharePublishEmbedSidebar/components/ConfigureEmbedDashboardButton';
import { useModal } from '@/features/modals/modalSlice';
import { EmbedDashboardConfigurations } from '@/features/dashboard/components/EmbedDashboardConfigurations';
import { useEmbedDashboard } from '@/hooks/useEmbedDashboard';
import { ConfigureEmbedModal } from '@/features/dashboard/components/ConfigureEmbedDashboardModal';
import { userAction } from '@/util/helpers/ajax-helpers';

const infoBannerContent = {
  private:
    'Embed this dashboard directly in your own app (via an iframe or link) and automatically filter the data so that each customer only ever sees the data they should.',
  public: 'Embed this dashboard directly in your own app or website.',
};

const learnMoreUrl = {
  private: 'https://guide.trevor.io/hc/en-us/articles/10596213303837',
  public:
    'https://guide.trevor.io/hc/en-us/articles/6097998784413-8-Embed-dashboards',
};

const EmbedDashboardTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
`;

const LearnMoreLink = styled.a`
  text-decoration: underline;
  font-weight: bold;
  color: inherit;
`;

export const EmbedDashboardTab = () => {
  const { isPublic } = useSelector(getDashboardState);
  const { isConfigured, isLoading } = useEmbedDashboard();

  const [isModalOpen, setIsModalOpen] = useModal();

  const handleModalOpen = () => {
    userAction('embed-dashboards-sidebar-embed-dashboard', {
      action: 'configure-dashboard-embed-modal-open',
    });
    setIsModalOpen();
  };

  return (
    <>
      <EmbedDashboardTabContainer>
        <SectionHeader iconName="web" title="Embed in your web application" />
        <Banner severity="info">
          {infoBannerContent[isPublic ? 'public' : 'private']}&nbsp;
          <br />
          <br />
          <LearnMoreLink
            onClick={() =>
              userAction('embed-dashboards-sidebar-embed-dashboard', {
                action: 'learn-more-about',
              })
            }
            href={learnMoreUrl[isPublic ? 'public' : 'private']}
            target="_blank"
          >
            Learn how to use this feature
          </LearnMoreLink>
        </Banner>
        {!isLoading && !isConfigured && (
          <ConfigureEmbedDashboardButton onClick={handleModalOpen} />
        )}
        <EmbedDashboardConfigurations />
        {!isLoading && isConfigured && (
          <ConfigureEmbedDashboardButton onClick={handleModalOpen} />
        )}
      </EmbedDashboardTabContainer>
      {isModalOpen && <ConfigureEmbedModal />}
    </>
  );
};
